import { useId, useEffect } from 'react';
import { useHandleOnEscape } from '@grandvisionhq/utils';
import { useEscapeHandlerStack } from '../EscapeHandlerStack.js';

const useStackedHandleOnEscape = ({ isOpen , handler  })=>{
    const id = useId();
    const escapeHandlerStack = useEscapeHandlerStack();
    const regularEventListener = useHandleOnEscape({
        handler
    });
    useEffect(()=>{
        if (!isOpen) return;
        if (escapeHandlerStack) {
            escapeHandlerStack.registerHandler({
                id,
                handler
            });
            return ()=>escapeHandlerStack.unregisterHandler(id)
            ;
        } else {
            regularEventListener.registerHandleOnEscape();
            return ()=>regularEventListener.registerHandleOnEscape()
            ;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen
    ]);
};

export { useStackedHandleOnEscape };
//# sourceMappingURL=use-stacked-handle-on-escape.js.map
